<template>
  <div class="search">
    <input type="text" :placeholder="placeholder" :value="value" v-debounce:500ms="() => $emit('input', $refs.search.value)" ref="search">
    <button></button>
  </div>
</template>

<script>
export default {
  name: 'search',
  props: {
    value: String,
    width: String,
    placeholder: String
  }
}
</script>

<style scoped lang="scss">
.search {
  position: relative;
  height: 50px;
  width: 560px;

  input {
    width: 100%;
    height: 100%;
    background: #FFFFFF;
    border: 1px solid #DBBFA7;
    border-radius: 5px;
    padding-left: 20px;
    color: #383838;
    font-size: 16px;
    font-family: "Open Sans", sans-serif;

    &::placeholder {
      font-size: 16px;
      color: #808080;
    }
  }

  button {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    background-color: transparent;
    border: none;
    background-image: url('../../../assets/images/icons/search.svg');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    cursor: pointer;
  }
}
</style>
